import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import {
  getTokenConsumption,
  TokenConsumptionResponse,
} from '@/services/composer-dashboard/get-token-consumption';

export const useGetTokenConsumption = (
  startDate?: string,
  endDate?: string,
  labelIds?: string[],
  options?: { enabled?: boolean },
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  const params = {
    ...(startDate && { start_date: startDate }),
    ...(endDate && { end_date: endDate }),
    ...(labelIds?.length && { label_ids: labelIds }),
  };

  return useQuery<TokenConsumptionResponse>({
    queryKey: ['token-consumption', orgId, startDate, endDate, labelIds ?? []],
    queryFn: () => getTokenConsumption(orgId!, params),
    enabled: !!orgId && (options?.enabled ?? true),
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
  });
};
